"use client";
import { Button } from "@/components/ui/button";
import { Transaction } from "@/types/transaction-type";
import { useModalStore } from "@/zustand-hooks/modal";
import React from "react";

const IdButton = ({ transaction }: { transaction: Transaction }) => {
  const toggleOpen = useModalStore((state) => state.toggleIsOpen);
  const isOpen = useModalStore((state) => state.isOpen);
  const setTransaction = useModalStore((state) => state.setTransaction);

  return (
    <Button
      className="text-white font-bold"
      onClick={() => {
          setTransaction(transaction)
        toggleOpen();
      }}
    >
      #{transaction.id}
    </Button>
  );
};

export default IdButton;
